// extracted by mini-css-extract-plugin
module.exports = {"spam-content":"report_spam-content__sZjrt","header":"report_header__E9Bi_","spam":"report_spam__idyzh","is-reported":"report_is-reported__U8j1G"};